// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32378":"b2251279","43117":"e77bdb31","49603":"4cea45b8"}[chunkId] + ".chunk.css";
};